import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import MechanicsList from "../components/MechanicsList";

const MechanicsPage = () => {
  const { t } = useTranslation();
  const { lang } = useParams();

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <h1 className="text-3xl font-bold text-center mb-6 text-gray-900">
        {t("mechanics.title")}
      </h1>
      <p className="text-center max-w-3xl mx-auto text-gray-700 mb-8">
        {t("mechanics.description")}
      </p>
      <MechanicsList lang={lang} />
    </div>
  );
};

export default MechanicsPage;
